import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EScolaMaterial } from 'src/app/domain/enums/scola-material';
import { MPCA } from 'src/app/domain/mpca';

import { StringTool } from '../../mapping/string.tool';
import { StringConverter } from '../string-converter';
import { EDegradationLevel } from 'src/app/domain/enums/degradation-level';
import { MatDialogRef } from '@angular/material/dialog';
import { MaterielAdduction } from 'src/app/domain/Adduction-air/materiel-adduction';
import { PrelevementAir } from 'src/app/domain/Adduction-air/prelevement-air';
import { ETypePrelevementAir } from 'src/app/domain/Adduction-air/enum/type-prelevement-air';

@Component({
    selector: 'adduction-prelevement-box',
    templateUrl: 'adduction-prelevement-box.html',
    styleUrls: ['./adduction-prelevement-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class AdductionPrelevementBoxDialog implements OnInit {
    public PrelevementTypeAdductionList: string[] = Object.values(ETypePrelevementAir)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getPrelevementAdductionName(x));
    Model: PrelevementAir = new PrelevementAir();
    // public ScolaMaterialList: string[] = Object.values(EScolaMaterial)
    //     .filter(x => isNaN(Number(x)))
    //     .map((x: any) => x);
    // public DegradationLevelList: string[] = Object.values(EDegradationLevel)
    //     .filter(x => !isNaN(Number(x)))
    //     .map((x: any) => StringConverter.getDegradationLevelName(x));

    constructor(
        public dialogRef: MatDialogRef<AdductionPrelevementBoxDialog>) {

    }

    ngOnInit() {
    }

    canFinish() {
        return StringTool.isNotNullOrEmpty(this.Model.ReferenceTube);
    }

    onCancel() {
        this.dialogRef.close();
    }

    finish() {
        if (!this.canFinish()) {
            return;
        }
        this.dialogRef.close(this.Model);
    }
}
